export const pwaEvent = 'PwaEvent';
export const pwaEvents =  {
    PWA_UNSUPPORTED_BROWSER: 'PwaNotSupported',
    PWA_BANNER_NOT_DISPLAYED: 'PwaBannerNotDisplayed',
    PWA_PAGE_CLOSED_BEFORE_BANNER: 'PwaPageClosedBeforeBanner',
    PWA_INSTALL_BANNER_DISPLAYED: 'PwaBannerDisplayed',
    PWA_INSTALL_BANNER_ACCEPT_BUTTON_CLICKED: 'PwaInstallBannerAcceptButtonClicked',
    PWA_INSTALL_BANNER_DECLINE_BUTTON_CLICKED: 'PwaInstallBannerDeclineButtonClicked',
    PWA_INSTALL_MENU_ITEM_CLICKED: 'PwaMenuItemClicked',
    PWA_INSTALL_ACCEPTED: 'PwaInstallationAccepted',
    PWA_INSTALL_DECLINED: 'PwaInstallationDeclined',
    PWA_INSTALLED: 'PwaInstalled',
};
